export default "__VITE_ASSET__DhlbF6E7__"